import { render, staticRenderFns } from "./SettingsImage.vue?vue&type=template&id=36fbf2a2&scoped=true&"
import script from "./SettingsImage.vue?vue&type=script&lang=js&"
export * from "./SettingsImage.vue?vue&type=script&lang=js&"
import style0 from "./SettingsImage.vue?vue&type=style&index=0&id=36fbf2a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbf2a2",
  null
  
)

export default component.exports